﻿//Consent data provided by Termly
var termlyApiCach = JSON.parse(window.localStorage.getItem("TERMLY_API_CACHE"))
//collection of iframes that were changed at render
var iframes = document.querySelectorAll('iframe[data-src][data-requiresconsent]')
//Button to load consent page
var consentRequired = document.getElementsByClassName('cookie-consent__iframe')[0].cloneNode(true)
consentRequired.classList.add('required')

var termlyConsent
if (typeof (termlyApiCach) !== 'undefined' && termlyApiCach !== null && typeof (termlyApiCach.TERMLY_COOKIE_CONSENT) != 'undefined') {
    termlyConsent = termlyApiCach.TERMLY_COOKIE_CONSENT.value
}

iframes.forEach(function (el, i) {
    //check that only iframes that need advertising consent are changed
    if (ConsentGiven(el)) {
        //Show the video if the consent is approved
        el.setAttribute('src', el.getAttribute('data-src'))
        el.removeAttribute('data-src')
    } else {
        //add a wrapper to the iframe if the consent was not given. This provides the button to change consent options
        var wrapper = consentRequired.cloneNode(true);
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
    }
})
function ConsentGiven(el) {
    return typeof (termlyConsent) !== 'undefined' && el.getAttribute('data-requiresconsent') === 'advertising' && termlyConsent.advertising === true
}